export default __webpack_public_path__ + "6d9976637adc7eea0a25d16bcf50c243.svg";